const styles = {
  linkContainer: {
    fontSize: 12,
    mb: 1,
  },
  annotation: {
    fontSize: 12,
  },
  button: {
    fontSize: 12,
  },
  link: {
    maxWidth: { xs: 300, md: 150 },
    textOverflow: "ellipsis",
    cursor: "pointer",
    color: "primary.main",
    fontSize: 12,
  },
};

export default styles;
